export default __webpack_public_path__ + "static/media/blog-sealer-006.515edbcc.jpg";